//import FastImage from "../../../../globals/elements/fastimg";
import SectionHome1Plans from "../../sections/home/home1/section-home1-plans";
import SectionHome1Team from "../../sections/home/home1/section-home1-team";
import SectionHome2Video from "../../sections/home/home2/section-home2-video";
import SectionHome3WhatWeDo from "../../sections/home/home3/section-home3-what-we-do";
import SectionHome3WhyChooseUs from "../../sections/home/home3/section-home3-why-choose-us";
import { publicUrlFor, route } from "../../../globals/constants";
import { Link, NavLink } from "react-router-dom";
function AboutUsPage() {
    return (
        <>
            {/* Our Mission */}
            <SectionHome3WhatWeDo />

            {/* Our Services */}
            {/* Our Services */}
            {/* Our Team */}
            {/* <SectionHome1Team /> */}
            <div className="section-full bg-change-section overlay-wraper p-t80 p-b50">
                <div className="overlay-main bg-secondry opacity-09" />
                <div className="bg-changer">
                    <div className="section-bg active" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg1.jpg")})` }} />
                    <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg2.jpg")})` }} />
                    <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg3.jpg")})` }} />
                    <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg4.jpg")})` }} />
                    <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg5.jpg")})` }} />
                    <div className="section-bg" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg6.jpg")})` }} />
                </div>
                <div className="container">
                    {/* TITLE START*/}
                    <div className="section-head text-center text-white">
                        <h2 data-title="Services">Our Services </h2>
                        <div className="mt-separator-outer">
                            <div className="mt-separator site-bg-primary" />
                        </div>
                    </div>
                    {/* TITLE END*/}
                    <div className="section-content">
                        <div className="row d-flex justify-content-center">

                            <div className="col-lg-4 col-md-6 m-b30">
                                <NavLink to={route.services.freightforwarding}>
                                    <div className="mt-icon-box-wraper center p-a30 bgcall-block bdr-1 bdr-solid bdr-primary hover-shadow">
                                        <div className="mt-icon-box-sm radius bdr-2 bdr-solid bdr-white m-b20">
                                            <span className="icon-cell site-text-primary"><i className="flaticon-ship-1" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte m-b15 site-text-primary">Freight Forwarding</h4>
                                            <p className="text-white">Ensuring seamless and efficient transportation of your goods worldwide.</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>

                            <div className="col-lg-4 col-md-6 m-b30">
                                <NavLink to={route.services.custombroking}>
                                    <div className="mt-icon-box-wraper center p-a30 bgcall-block bdr-1 bdr-solid bdr-primary hover-shadow">
                                        <div className="mt-icon-box-sm radius bdr-2 bdr-solid bdr-white m-b20">
                                            <span className="icon-cell site-text-primary"><i className="flaticon-airplane" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte m-b15 site-text-primary">Custom Broking</h4>
                                            <p className="text-white">Streamlining the process of customs clearance for smooth and efficient international trade.</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-lg-4 col-md-6 m-b30">
                                <NavLink to={route.services.transportation}>
                                    <div className="mt-icon-box-wraper center p-a30 bgcall-block bdr-1 bdr-solid bdr-primary hover-shadow">
                                        <div className="mt-icon-box-sm radius bdr-2 bdr-solid bdr-white m-b20">
                                            <span className="icon-cell site-text-primary"><i className="flaticon-truck" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte m-b15 site-text-primary">Transportation Services</h4>
                                            <p className="text-white">Providing reliable and efficient transportation solutions for your cargo.</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-lg-4 col-md-6 m-b30">
                                <NavLink to={route.services.warehousing}>
                                    <div className="mt-icon-box-wraper center p-a30 bgcall-block bdr-1 bdr-solid bdr-primary hover-shadow">
                                        <div className="mt-icon-box-sm radius bdr-2 bdr-solid bdr-white m-b20">
                                            <span className="icon-cell site-text-primary"><i className="flaticon-transport-4" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte m-b15 site-text-primary">Warehousing Services</h4>
                                            <p className="text-white">Secure and strategically located warehousing solutions to store your goods.</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>
                            <div className="col-lg-4 col-md-6 m-b30">
                                <NavLink to={route.services.logisticsconsultants}>
                                    <div className="mt-icon-box-wraper center p-a30 bgcall-block bdr-1 bdr-solid bdr-primary hover-shadow">
                                        <div className="mt-icon-box-sm radius bdr-2 bdr-solid bdr-white m-b20">
                                            <span className="icon-cell site-text-primary"><i className="flaticon-forklift-1" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte m-b15 site-text-primary">Logistics Consultant</h4>
                                            <p className="text-white">Expert logistics consulting to optimize your supply chain operations.</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* Why Choose us */}
            <SectionHome3WhyChooseUs />
            {/*Video Section */}
            <SectionHome2Video />

            {/* OUR PLANS  */}
            {/* <SectionHome1Plans /> */}
        </>
    )
}
export default AboutUsPage;